import { useContext, useState, useEffect } from 'react';
import AuthorizationContext from './AuthorizationContext';
import { target } from '../config/awsExports';

const usePermission = (permission) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  const { isAllowedTo } = useContext(AuthorizationContext);


  // Helper to check permission with environment
  const checkEnvPermission = async (perm) => {
    if (perm.includes('[')) {
      const permName = perm.split('[')[0];
      const envMatches = [...perm.matchAll(/'([^']+)'/g)];
      const envs = envMatches.map(match => match[1]);
      if (envs.includes(target)) {
        return await isAllowedTo(permName);
      }
      return false;
    }
    return await isAllowedTo(perm);
  };

  useEffect(() => {
    let isMounted = true;

    const checkPermissions = async () => {
      try {
        let isAllowed = false;

        if (Array.isArray(permission)) {
          const permissionPromises = permission.map((perm) => checkEnvPermission(perm));
          const results = await Promise.all(permissionPromises);
          isAllowed = results.some((result) => result === true);
        } else {
          isAllowed = await checkEnvPermission(permission);
        }

        if (isMounted) {
          setAllowed(isAllowed);
          setLoading(false);
        }
      } catch (err) {
        console.debug('isAllowed error', err);
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    checkPermissions();

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      isMounted = false;
    };
  }, [permission, isAllowedTo]);

  return [loading, allowed];
};

export default usePermission;
